import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CakeLandingPage.css';

const CakeLandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="cake-landing-page">

      {/* NAVBAR */}
      <header className="cake-navbar">
        <div className="cake-navbar-inner">

          <div className="cake-brand">
            <div className="cake-brand-icon">🎂</div>

            <div className="cake-brand-text">
              <h2>VAKRA CAKE</h2>
              <span>Cake Business Platform</span>
            </div>
          </div>

          <nav className="cake-nav-links">
            <a href="#features">Features</a>
            <a href="#how-it-works">How It Works</a>
            <a href="#business">For Business</a>
          </nav>

          <div className="cake-nav-buttons">
            <button
              type="button"
              className="cake-login-button"
              onClick={() => navigate('/cake/login')}
            >
              Login
            </button>

            <button
              type="button"
              className="cake-signup-button"
              onClick={() => navigate('/cake/signup')}
            >
              Sign Up
            </button>
          </div>

        </div>
      </header>

      {/* HERO SECTION */}
      <main>
        <section className="cake-hero-section">

          <div className="cake-hero-left">

            <div className="cake-small-badge">
              Made for Cake Shops & Home Bakers
            </div>

            <h1>
              Manage Your
              <span> Cake Business </span>
              with VAKRA
            </h1>

            <p className="cake-hero-description">
              Add your cakes, receive customer orders, manage custom cake
              requirements, billing, customers and business records from one
              simple platform.
            </p>

            <div className="cake-hero-buttons">

              <button
                type="button"
                className="cake-primary-button"
                onClick={() => navigate('/cake/signup')}
              >
                Start Now
              </button>

              <button
                type="button"
                className="cake-demo-button"
                onClick={() => navigate('/cake/book-demo')}
              >
                Book Demo
              </button>

            </div>

            <div className="cake-hero-points">
              <span>✓ Easy Setup</span>
              <span>✓ Online Orders</span>
              <span>✓ Customer Records</span>
            </div>

          </div>

          {/* DASHBOARD PREVIEW */}
          <div className="cake-hero-right">

            <div className="cake-dashboard-preview">

              <div className="cake-browser-bar">
                <span></span>
                <span></span>
                <span></span>
              </div>

              <div className="cake-preview-content">

                <aside className="cake-preview-sidebar">
                  <div className="cake-preview-logo">🎂</div>

                  <div className="cake-preview-menu active"></div>
                  <div className="cake-preview-menu"></div>
                  <div className="cake-preview-menu"></div>
                  <div className="cake-preview-menu"></div>
                  <div className="cake-preview-menu"></div>
                </aside>

                <div className="cake-preview-main">

                  <div className="cake-preview-heading">
                    <h3>Welcome Back 👋</h3>
                    <p>Your cake business overview</p>
                  </div>

                  <div className="cake-preview-stats">

                    <div className="cake-stat-card">
                      <span>Today's Orders</span>
                      <strong>18</strong>
                    </div>

                    <div className="cake-stat-card">
                      <span>Pending Orders</span>
                      <strong>4</strong>
                    </div>

                    <div className="cake-stat-card">
                      <span>Today's Sales</span>
                      <strong>₹12,450</strong>
                    </div>

                  </div>

                  <div className="cake-preview-orders">

                    <div className="cake-preview-orders-title">
                      Recent Orders
                    </div>

                    <div className="cake-preview-order-row">
                      <span>#CK1001</span>
                      <span>Chocolate Truffle</span>
                      <span className="cake-status-new">New</span>
                    </div>

                    <div className="cake-preview-order-row">
                      <span>#CK1002</span>
                      <span>Birthday Cake</span>
                      <span className="cake-status-preparing">
                        Preparing
                      </span>
                    </div>

                    <div className="cake-preview-order-row">
                      <span>#CK1003</span>
                      <span>Photo Cake</span>
                      <span className="cake-status-ready">Ready</span>
                    </div>

                  </div>

                </div>
              </div>
            </div>

          </div>

        </section>

        {/* FEATURES */}
        <section
          id="features"
          className="cake-features-section"
        >

          <div className="cake-section-heading">
            <span>Simple Business Management</span>

            <h2>
              Everything You Need for Your Cake Business
            </h2>

            <p>
              Manage all important daily work from one place.
            </p>
          </div>

          <div className="cake-feature-grid">

            <div className="cake-feature-card">
              <div className="cake-feature-icon">🎂</div>

              <h3>Cake Management</h3>

              <p>
                Add cakes, prices, images, weights, flavors and availability.
              </p>
            </div>

            <div className="cake-feature-card">
              <div className="cake-feature-icon">📦</div>

              <h3>Order Management</h3>

              <p>
                Receive and manage new, preparing, ready and completed orders.
              </p>
            </div>

            <div className="cake-feature-card">
              <div className="cake-feature-icon">✨</div>

              <h3>Custom Cake Details</h3>

              <p>
                Receive cake message, reference design, theme and instructions.
              </p>
            </div>

            <div className="cake-feature-card">
              <div className="cake-feature-icon">👥</div>

              <h3>Customers</h3>

              <p>
                Keep customer details and order history organized.
              </p>
            </div>

            <div className="cake-feature-card">
              <div className="cake-feature-icon">🧾</div>

              <h3>Billing</h3>

              <p>
                Manage bills, payments and order amounts easily.
              </p>
            </div>

            <div className="cake-feature-card">
              <div className="cake-feature-icon">📊</div>

              <h3>Records</h3>

              <p>
                Check old orders, sales records and business history.
              </p>
            </div>

          </div>
        </section>

        {/* HOW IT WORKS */}
        <section
          id="how-it-works"
          className="cake-how-section"
        >

          <div className="cake-section-heading">
            <span>How It Works</span>

            <h2>
              Start in Four Simple Steps
            </h2>
          </div>

          <div className="cake-step-grid">

            <div className="cake-step-card">
              <div className="cake-step-number">1</div>

              <h3>Create Account</h3>

              <p>
                Register your cake shop or home baking business.
              </p>
            </div>

            <div className="cake-step-card">
              <div className="cake-step-number">2</div>

              <h3>Add Cakes</h3>

              <p>
                Add your cake products, prices and customization options.
              </p>
            </div>

            <div className="cake-step-card">
              <div className="cake-step-number">3</div>

              <h3>Receive Orders</h3>

              <p>
                Customers place orders and you manage them from your panel.
              </p>
            </div>

            <div className="cake-step-card">
              <div className="cake-step-number">4</div>

              <h3>Manage Business</h3>

              <p>
                Handle orders, customers, billing and records in one place.
              </p>
            </div>

          </div>
        </section>

        {/* BUSINESS SECTION */}
        <section
          id="business"
          className="cake-business-section"
        >

          <div className="cake-business-left">

            <span className="cake-section-small-label">
              Who Can Use VAKRA Cake?
            </span>

            <h2>
              Built for Different Types of Cake Businesses
            </h2>

            <p>
              Whether you have a cake shop, bakery store or home baking
              business, VAKRA Cake helps you manage customer orders simply.
            </p>

            <div className="cake-business-list">
              <div>✓ Cake Shops</div>
              <div>✓ Home Bakers</div>
              <div>✓ Bakery Stores</div>
              <div>✓ Custom Cake Studios</div>
            </div>

          </div>

          <div className="cake-business-right">

            <div className="cake-demo-card">

              <div className="cake-demo-icon">💻</div>

              <h3>
                Want to See the Platform?
              </h3>

              <p>
                Book a demo and our team will help you understand how VAKRA
                Cake can work for your business.
              </p>

              <button
                type="button"
                onClick={() => navigate('/cake/book-demo')}
              >
                Book Demo
              </button>

            </div>

          </div>

        </section>

        {/* CTA SECTION */}
        <section className="cake-cta-section">

          <div className="cake-cta-content">

            <div>
              <h2>
                Ready to Manage Your Cake Business?
              </h2>

              <p>
                Create your account and start using VAKRA Cake.
              </p>
            </div>

            <div className="cake-cta-buttons">

              <button
                type="button"
                className="cake-cta-signup"
                onClick={() => navigate('/cake/signup')}
              >
                Create Account
              </button>

              <button
                type="button"
                className="cake-cta-login"
                onClick={() => navigate('/cake/login')}
              >
                Login
              </button>

            </div>

          </div>

        </section>

      </main>

      {/* FOOTER */}
      <footer className="cake-footer">

        <div className="cake-footer-top">

          <div className="cake-footer-brand">
            <h3>🎂 VAKRA CAKE</h3>

            <p>
              Simple cake business management platform by VAKRA.
            </p>
          </div>

          <div className="cake-footer-links">

            <a href="#features">
              Features
            </a>

            <a href="#how-it-works">
              How It Works
            </a>

            <button
              type="button"
              onClick={() => navigate('/cake/login')}
            >
              Login
            </button>

            <button
              type="button"
              onClick={() => navigate('/cake/signup')}
            >
              Sign Up
            </button>

          </div>

        </div>

        <div className="cake-footer-bottom">
          © {new Date().getFullYear()} VAKRA. All rights reserved.
        </div>

      </footer>

    </div>
  );
};

export default CakeLandingPage;
